/*
 * @CopyRight    : 广州仰望星空云科技有限公司
 * @Author       : Kyle
 * @Email        : linyukai@xinyu668.com
 * @CreateTime   : 2023-08-07 15:21:11
 * @Description  : 请求初始化
 */
import { constConf } from '@GLOBAL/constConf';
import { apiUrl } from '@GLOBAL/bridge';
import { createRequest } from '@ywxk/request'

const { PROJECT, IS_PROD, ENV, APPID, CLIENT, IS_DEBUG } = constConf

export function initRequest(pbJson) {
  let app = ''
  switch (PROJECT) {
    case 'oxygen':
    case 'caramel':
    case 'callme':
    case 'popo':
      app = 'oxygen'
      break;
    case 'yes':
    case 'yoyo':
    case 'memoryDiary':
    case 'bantang':
      app = 'hydrogen'
      break;
    default:
      app = PROJECT
      break;
  }
  const params = {
    // 优先使用客户端传入
    url: apiUrl + '/proxymsg',
    // url: 'https://api-bk.shuntongtong.com' + '/proxymsg',
    pbJson,
    isDebug: IS_DEBUG,
    // 方便本地调试查看
    isProd: IS_PROD && !IS_DEBUG,
    rpcOpts: {
      app,
      application: PROJECT,
      env: ENV,
      appid: APPID,
      client: CLIENT,
    }
  }


  createRequest(params);
};
